export default function() {
    return {
        startNowItems: [],
        customToolbar: [
            ["bold", "italic", "underline"],
            [
                {list: "ordered"},
                {list: "bullet"}
            ],
            ["image"],
            [{ 'size': ['small', false] }]
        ],
        errors: {
            contractor: [],
            professional: []
        }
    }
}
